import React from "react";
import { useTranslation } from "react-i18next";
import {
  ArrowDown,
  ArrowRight,
  AtSign,
  Database,
  FileText,
  Mail,
  MessageSquare,
  Printer,
  Send,
  Settings2,
  Smartphone,
} from "lucide-react";

const channelIcons = [
  { key: "email", icon: Mail },
  { key: "chat", icon: MessageSquare },
  { key: "mobile", icon: Smartphone },
  { key: "web", icon: AtSign },
  { key: "print", icon: Printer },
  { key: "archive", icon: FileText },
];

function FlowChart() {
  const { t } = useTranslation();
  const businessApps = Array.from({ length: 3 });
  const processSteps = [
    { key: "document", icon: FileText },
    { key: "preparing", icon: Settings2 },
    { key: "multichannel", icon: Send },
  ];

  return (
    <section className="px-5 pb-24 md:px-6 md:pb-32">
      <div className="mx-auto max-w-2xl">
        <div className="rounded-2xl bg-white p-6 md:p-10 lg:p-12">
          <div className="grid items-stretch gap-6 xl:grid-cols-[minmax(0,0.9fr)_auto_minmax(0,1.2fr)_auto_minmax(0,0.9fr)] xl:gap-5">
            <div className="flex flex-col justify-center">
              <h2 className="mb-4 text-xl font-bold leading-tight tracking-[-0.04em] text-main-dark">
                {t("pages.ccm.flowchart.sourcesTitle")}
              </h2>
              <div className="space-y-3">
                {businessApps.map((_, index) => (
                  <div className="flex items-center gap-3 rounded-xl bg-gray px-4 py-3 text-main-dark" key={`business-app-${index}`}>
                    <Database className="h-5 w-5 shrink-0 text-contrast" strokeWidth={1.75} />
                    <span className="text-sm font-semibold leading-snug">
                      {t("pages.ccm.flowchart.buisnessapp")}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-center py-1 xl:items-center xl:py-0">
              <ArrowDown className="h-6 w-6 text-contrast xl:hidden" strokeWidth={1.75} />
              <ArrowRight className="hidden h-7 w-7 text-contrast xl:block" strokeWidth={1.75} />
            </div>

            <div className="rounded-2xl bg-main p-6 text-white md:p-7">
              <h2 className="mb-5 text-xl font-bold leading-tight tracking-[-0.04em] text-white">
                {t("pages.ccm.flowchart.platformTitle")}
              </h2>
              <ol className="divide-y divide-white/25">
                {processSteps.map(({ key, icon: Icon }) => (
                  <li className="flex items-center gap-3 py-4 first:pt-0 last:pb-0" key={key}>
                    <Icon className="h-5 w-5 shrink-0 text-[#fff1e8]" strokeWidth={1.75} />
                    <span className="text-sm font-semibold leading-snug text-white">
                      {t(`pages.ccm.flowchart.${key}`)}
                    </span>
                  </li>
                ))}
              </ol>
            </div>

            <div className="flex justify-center py-1 xl:items-center xl:py-0">
              <ArrowDown className="h-6 w-6 text-contrast xl:hidden" strokeWidth={1.75} />
              <ArrowRight className="hidden h-7 w-7 text-contrast xl:block" strokeWidth={1.75} />
            </div>

            <div className="flex flex-col justify-center">
              <h2 className="mb-4 text-xl font-bold leading-tight tracking-[-0.04em] text-main-dark">
                {t("pages.ccm.flowchart.channelsTitle")}
              </h2>
              <div className="grid grid-cols-2 gap-3">
                {channelIcons.map(({ key, icon: Icon }) => (
                  <div className="flex items-center gap-2 rounded-xl bg-gray px-3 py-3 text-main-dark" key={key}>
                    <Icon className="h-4 w-4 shrink-0 text-contrast" strokeWidth={1.75} />
                    <span className="text-sm font-semibold">
                      {t(`pages.ccm.flowchart.channels.${key}`)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FlowChart;
